import { render } from "./SelectCor.vue?vue&type=template&id=5c1af108&scoped=true"
import script from "./SelectCor.vue?vue&type=script&lang=js"
export * from "./SelectCor.vue?vue&type=script&lang=js"

import "./SelectCor.vue?vue&type=style&index=0&id=5c1af108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1af108"]])

export default __exports__